import React, { useState, useEffect, useRef } from 'react';

export const ImagenModal = ({ imageUrl, onClose }) => {

  useEffect(() => {
    // Función que se ejecuta cuando se presiona una tecla
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose(); // Llama a la función para cerrar si la tecla es "Escape"
      }
    };

    // Añade el "oyente" de eventos al documento cuando el modal se monta
    document.addEventListener('keydown', handleKeyDown);

    // 3. Función de limpieza: Se ejecuta cuando el modal se "desmonta" (desaparece)
    // Es muy importante para evitar que el evento siga activo innecesariamente.
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);
  
  return (
    // Contenedor principal (backdrop)
    <div
      onClick={onClose} // Cierra el modal al hacer clic en el fondo
      className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50 transition-opacity duration-300"
    >
      {/* Contenedor de la imagen (para evitar que el clic en la imagen cierre el modal) */}
      <div className="relative p-4" onClick={(e) => e.stopPropagation()}>
        {/* Botón para cerrar */}
        <button
          onClick={onClose}
          className="absolute -top-2 -right-2 bg-white rounded-full p-1 text-black hover:bg-gray-200 transition-transform transform hover:scale-110"
          style={{ zIndex: 10 }}
          aria-label="Cerrar vista previa"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* La imagen en sí */}
        <img
          src={imageUrl}
          alt="Vista previa de la imagen"
          className="max-w-[90vw] max-h-[90vh] rounded-lg shadow-2xl"
        />
      </div>
    </div>
  );

};